import * as React from "react";
import { Segment, Step, Dimmer, Loader, Container, StepGroup, StepContent, StepTitle } from "@/components/bp/bp-ui";
// import { BrowserRouter, Route, Redirect, Switch } from "react-router-dom";
import { ReviewCalculate } from "./ReviewCalculate";
import { Parameters } from "./Parameters";
import { CaseRunCalculateModel, CaseRunClient, ClientResources } from "@app/api2/api";
import { HandlerRegistry } from "./RunTypes/HandlerRegistry";
import { PageHeader } from "@common/PageHeader";
import { insertComponentsIntoText } from "@common/Utils";
import { BPFormError } from "@common/BPFormError";
import { TranslationContext } from "../Contexts/TranslationContext";
import { Routes, Route, Navigate } from "react-router-dom";
import { IRouter, RouteContent } from "@common/RouteContent";
import { BPContainer } from "@/components/bp/bpcontainer";

interface ICaseRunCalculateProps {
    runType: string;
    caseRunId: number;
    labId: number;
    caseId: number;
    baseUrl: string;
    routerProps: IRouter;
}

class CaseRunCalculateState {
    model: CaseRunCalculateModel;
    step: string = "parameters";
    loading: boolean = true;
    showServerErrors: boolean = false;
    serverErrors: string[] = [];
}

export class CaseRunCalculate extends React.Component<ICaseRunCalculateProps, CaseRunCalculateState> {
    private _client = new CaseRunClient();
    public get client() {
        return this._client;
    }
    public set client(value) {
        this._client = value;
    }

    constructor(props, context) {
        super(props, context);

        this.state = new CaseRunCalculateState();
    }

    componentDidMount() {
        // console.log('CaseRunCalculate componentDidMount', this.props);
        this.client.getEmptyCalculate(this.props.labId, this.props.caseId, this.props.caseRunId, this.props.runType)
            // CaseRunApi.getCalculate(this.props.labId, this.props.caseId, this.props.caseRunId, this.props.runType)
            .then((r) => {
                this.setState({ model: r, loading: false });

                // if no parameters just save the model
                if (r.parameters.findIndex(x => x.userVisible) < 0)
                    this.reviewComplete();
            });
    }

    getRunTypeHandler(model) {
        return HandlerRegistry.getRunTypeHandler(model.runType);
    }

    //informationComplete = (values: any) => {
    //    this.setState({
    //        model: {
    //            ...this.state.model,
    //            description: values.description,
    //            hpUnknowns: values.hpUnknowns,
    //            hdUnknowns: values.hdUnknowns,
    //            hp: values.hp,
    //            hd: values.hd,
    //            evidence: values.evidence,
    //            populationId: values.populationId
    //        }
    //    });
    //}

    propsComplete = (values: any, routerProps: IRouter) => {
        var parameters = [...this.state.model.parameters];
        for (let k in values) {
            if (!values.hasOwnProperty(k)) {
                continue;
            }

            const param = parameters.find((p) => p.parameter === k);
            if (param) {
                param.value = values[k];
            } else {
                console.log("Unknown parameter", k);
            }
        }


        this.setState({
            ...this.state,
            model: {
                ...this.state.model,
                parameters: parameters
            }
        }, () => {
            routerProps.navigate(`../review`);
        })

        // routerProps.navigate(`../review`);

    }

    reviewComplete = () => {
        this.client.createCalculate(this.props.labId, this.props.caseId, this.props.caseRunId, this.props.runType, this.state.model)
            // CaseRunApi.createCalculate(this.props.labId, this.props.caseId, this.props.caseRunId, this.props.runType, this.state.model)
            .then((r) => {
                if (r.success) {
                    window.location.assign(r.url);
                } else {
                    this.setState(
                        {
                            ...this.state,
                            loading: false,
                            showServerErrors: true,
                            serverErrors: r.errors
                        });
                }
            });
    }

    renderHeader(props) {
        // console.log('renderHeader', props.location);
        return (<TranslationContext.Consumer>{t =>
            <StepGroup attached="top" widths={2}>
                {this.state.model && this.state.model.parameters.findIndex(x => x.userVisible) > -1 &&
                    <>
                        <Step active={props.location.pathname.endsWith("/parameters")} /*onClick={() => { props.history.push("/parameters") }}*/>
                            <StepContent>
                                <StepTitle>{t.common.parameters}</StepTitle>
                            </StepContent>
                        </Step>
                        <Step active={props.location.pathname.endsWith("/review")} /*onClick={() => { props.history.push("/review") }}*/>
                            <StepContent>
                                <StepTitle>{t.caseRun.review}</StepTitle>
                            </StepContent>
                        </Step>
                    </>
                }
            </StepGroup>
        }</TranslationContext.Consumer>);
    }

    parameterRenderer = () => {
        return this.getRunTypeHandler(this.state.model);
    }

    render() {
        if (this.state.loading || !this.state.model) {
            return (<TranslationContext.Consumer>{t =>
                <Dimmer inverted active={true}><Loader inverted>{t.caseRun.loadingData}</Loader></Dimmer>
            }</TranslationContext.Consumer>);
        }
        // console.log(this.props.baseUrl);
        return (<TranslationContext.Consumer>{t =>
            <BPContainer>
                <PageHeader
                    header={insertComponentsIntoText(t.caseRunView.calculate, {
                        '{runTypeName}': this.state.model ? t.runType[this.state.model.runType] : "",
                        '{caseName}': <a key='caseName' href={this.state.model ? this.state.model.caseUrl : ''}>{this.state.model ? this.state.model.caseName : ''}</a>,
                        '{caseRunId}': <a key='caseRunId' href={this.state.model ? this.state.model.caseRunUrl : ''}>{this.state.model ? this.state.model.caseRunId : ''}</a>
                    })} />
                <>

                    {this.renderHeader(this.props.routerProps)}
                    <Segment attached>
                        {!this.state.loading && <>
                            {this.state.model.parameters.findIndex(x => x.userVisible) > -1 &&
                                <>

                                    <Routes>
                                        <Route path="" element={<Navigate to={`parameters`} replace />} />
                                        <Route path={`parameters`} element={<RouteContent render={(router) => <Parameters parameterRenderer={this.parameterRenderer()} disableStutter={false} model={this.state.model} onComplete={values => this.propsComplete(values, router)} aic={false} />} />} />
                                        <Route path={`review`} element={<RouteContent render={(router) => <ReviewCalculate parameterRenderer={this.parameterRenderer()} model={this.state.model} onComplete={this.reviewComplete} />} />} />
                                    </Routes>
                                </>
                            }
                        </>}
                        {this.state.showServerErrors && this.state.serverErrors.length > 0 &&
                            <BPFormError errors={{ 'asdf': this.state.serverErrors[0] }} isValid={false} touched={true} />
                        }
                    </Segment>

                </>
            </BPContainer>
        }</TranslationContext.Consumer>);
    }
}
